import React from "react"
interface QuoteProps {
	text: string
}

export function Quote({text}: QuoteProps) {
	return <blockquote className="quote-text-container">&quot;{text}&quot;</blockquote>
}
